
const { getItem, getTitle } = require('./enum');

const EQUAL = 'EQUAL';
const LESS = 'LESS';
const LESS_EQUAL = 'LESS_EQUAL';
const GREAT = 'GREAT';
const GREAT_EQUAL = 'GREAT_EQUAL';
const DIFFERENT = 'DIFFERENT';
const LIKE = 'LIKE';

const ITEMS = [
    {
        key: EQUAL,
        title: '='
    },
    {
        key: LESS,
        title: '<'
    },
    {
        key: LESS_EQUAL,
        title: '<='
    },
    {
        key: GREAT,
        title: '>'
    },
    {
        key: GREAT_EQUAL,
        title: '>='
    },
    {
        key: DIFFERENT,
        title: '<>'
    },
    {
        key: LIKE,
        title: 'LIKE'
    }
];

function getConditionOperator(value) {
    return getItem(ITEMS, value);
}

function getConditionOperatorTitle(value) {
   return getTitle(ITEMS, value);
}

function getConditionOperators() {
    return ITEMS;
}

module.exports = {
    EQUAL,
    LESS,
    LESS_EQUAL,
    GREAT,
    GREAT_EQUAL,
    DIFFERENT,
    LIKE,
    getConditionOperator,
    getConditionOperatorTitle,
    getConditionOperators
};
